import React from "react";
import { Link } from "react-router-dom";
import "./Success.css";

const Success: React.FC = () => {
  return (
    <div className="success-page">
      <div className="container">
        <div className="check">&#x2713;</div>
        <h1>
          Thank <em>You</em>
        </h1>
        <p>
          Your enquiry has been received. Chef Hamish will be in touch within 24
          hours to discuss your occasion and begin designing your perfect menu.
        </p>
        <Link to="/" className="back-link">
          Back to Moments Brisbane
        </Link>
      </div>
    </div>
  );
};

export default Success;
